const POPOVER_WIDTH = 120;
const POPOVER_HEIGHT = 80;
const EDGE_BUFFER = 30;
const TAP_THRESHOLD = 8;
// 20px gets popover to edge of hotspot + 8 px for gap
const POPOVER_POSITION = 28;
const isMobile = window.innerWidth < 750 ? true : false;

function calculatePopoverPosition(container, popover, x, y, options = {}) {
    const containerWidth = container.offsetWidth;
    const   containerHeight = container.offsetHeight;
	const mobileDivOffset = 195;

	const hotspotXpx = (parseFloat(x) / 100) * containerWidth;
	const hotspotYpx = (parseFloat(y) / 100) * containerHeight;
	const rect = container.getBoundingClientRect();

	const spaceOnRight = (isMobile ? (containerWidth - hotspotXpx + mobileDivOffset - rect.left) :(containerWidth - hotspotXpx));
	const spaceOnLeft = (isMobile ? (hotspotXpx + rect.left ) : hotspotXpx);
	const spaceBelow = containerHeight - hotspotYpx;
	const spaceAbove = hotspotYpx;
	//calculates available space for popver using max height and fixed width 
	const canCenterVertically =
		(hotspotYpx >= POPOVER_HEIGHT / 2 + EDGE_BUFFER) &&
		(containerHeight - hotspotYpx >= POPOVER_HEIGHT / 2 + EDGE_BUFFER);

	const canCenterHorizontally =
		(hotspotXpx >= POPOVER_WIDTH / 2 + EDGE_BUFFER) &&
		(containerWidth - hotspotXpx >= POPOVER_WIDTH / 2 + EDGE_BUFFER);

	// Clear old classes
	popover.classList.remove('popover-right', 'popover-left', 'popover-above', 'popover-below');

	// position appropriate edge of popover at hotspot center
	// POPOVER_POSITION constant is based on hotspot being 40x40
	if (spaceOnRight >= POPOVER_WIDTH + EDGE_BUFFER && canCenterVertically) {
		popover.classList.add('popover-right');
		popover.style.setProperty('--popover-left', `calc(${x}% + ${POPOVER_POSITION}px)`);
		popover.style.setProperty('--yCoordinate', `${y}%`);

	} else if (spaceOnLeft >= POPOVER_WIDTH + EDGE_BUFFER && canCenterVertically) {
		popover.classList.add('popover-left');
		popover.style.setProperty('--popover-right', `calc(${100 - x}% + ${POPOVER_POSITION}px`);
		popover.style.setProperty('--yCoordinate', `${y}%`);

	} else if (spaceAbove >= POPOVER_HEIGHT + EDGE_BUFFER && canCenterHorizontally) {
		popover.classList.add('popover-above');
		popover.style.setProperty('--popover-bottom', `calc(${100 - y}% + ${POPOVER_POSITION}px)`);
		popover.style.setProperty('--xCoordinate', `${x}%`);


	} else if (spaceBelow >= POPOVER_HEIGHT + EDGE_BUFFER && canCenterHorizontally) {
		popover.classList.add('popover-below');
		popover.style.setProperty('--popover-top', `calc(${y}% + ${POPOVER_POSITION}px)`);
		popover.style.setProperty('--xCoordinate', `${x}%`);

	} else if (spaceOnRight < spaceOnLeft) {
		popover.classList.add('popover-left');
		popover.style.setProperty('--popover-right', `calc(${100 - x}% + ${POPOVER_POSITION}px`);
		popover.style.setProperty('--yCoordinate', `${y}%`);
	} else {
		// Fallback
		popover.classList.add('popover-right');
		popover.style.setProperty('--popover-left', `calc(${x}% + ${POPOVER_POSITION}px)`);
		popover.style.setProperty('--yCoordinate', `${y}%`);
	}
}

module.exports = {
	calculatePopoverPosition
};